import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

/**
 * Hook to check if the current user can manage users.
 * "Manage" means: invite new users or revoke user access (delete users).
 * This does NOT control role binding management - SpaceAdmins can manage role bindings.
 *
 * @returns {boolean} true if user is a root admin, false for SpaceAdmins and other users
 */
const useCanManageUsers = (): boolean => {
  const { viewer } = useTypedContext(AccountContext);
  return viewer.admin;
};

export default useCanManageUsers;
